import { render, staticRenderFns } from "./TabDetailProyek.vue?vue&type=template&id=3657ad09&scoped=true"
import script from "./TabDetailProyek.vue?vue&type=script&lang=js"
export * from "./TabDetailProyek.vue?vue&type=script&lang=js"
import style0 from "./TabDetailProyek.vue?vue&type=style&index=0&id=3657ad09&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3657ad09",
  null
  
)

export default component.exports